import 'swiper/css';
import 'swiper/css/pagination';

import { useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { Pagination } from 'swiper/modules';
import { SwiperSlide } from 'swiper/react';

import { TrlNewsSummary, TrlSectionTitle } from '»components/atoms';
import { TrlFormattedMessagePlain } from '»utils/i18n';

import { NewsContainer, SwiperStyled } from './TrlLatestNews.styles';

export const TrlLatestNews = ({ latestNews }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  const itemsPerGroup = isDesktop ? 3 : 1;

  const latestNewsGroups = latestNews
    .sort((a, b) => Number(a.visualOrder) - Number(b.visualOrder))
    .reduce((acc, currentItem, index) => {
      const chunkIndex = Math.floor(index / itemsPerGroup);

      if (!acc[chunkIndex]) acc[chunkIndex] = [];

      acc[chunkIndex].push(currentItem);

      return acc;
    }, []);

  return (
    <NewsContainer id="latestNewsContainer">
      {isDesktop && (
        <TrlSectionTitle
          title={TrlFormattedMessagePlain({ id: 'TRLT_UI-RECENT_NEWS' })}
          hasMarginBottom
        />
      )}

      <SwiperStyled
        loop
        pagination={{
          clickable: true,
        }}
        modules={[Pagination]}
      >
        {latestNewsGroups.map((item) => (
          <SwiperSlide key={item[0].id}>
            {item.map((news) => (
              <TrlNewsSummary
                key={news.id}
                date={news.contentDate}
                title={news.title}
                sourceId={news.sourceId}
                image={news.image}
                link={news.link}
                contSeq={news.contSeq}
                fileName={news.fileName}
                fileDescr={news.fileDescr}
                visibleFile={news.visibleFile}
                video={news.video}
              />
            ))}
          </SwiperSlide>
        ))}
      </SwiperStyled>
    </NewsContainer>
  );
};

TrlLatestNews.propTypes = {
  latestNews: PropTypes.array.isRequired,
};
